import { render, staticRenderFns } from "./TicketSetting.vue?vue&type=template&id=29e6301d"
import script from "./TicketSetting.vue?vue&type=script&lang=js"
export * from "./TicketSetting.vue?vue&type=script&lang=js"
import style0 from "./TicketSetting.vue?vue&type=style&index=0&id=29e6301d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports